export default __webpack_public_path__ + "images/home-video-install-service.jpg";